import I18n from 'I18n';
import { useState } from 'react';
import * as React from 'react';
import PortalIdParser from 'PortalIdParser';
import { useMutation } from 'data-fetching-client';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import UILink from 'UIComponents/link/UILink';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { CANDY_APPLE } from 'HubStyleTokens/colors';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { SAVE_NEW_ILS_LIST } from 'automation-ui-enrollment/queries/ILSListQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultListCreatedCallback = listId => {
  const url = `/contacts/${PortalIdParser.get()}/objectLists/${listId}`;
  window.open(url, '_blank');
};
const ILSListPreviewLink = ({
  filterBranch,
  workflowName,
  objectTypeId,
  linkLabel,
  listCreatedCallback = defaultListCreatedCallback,
  isExternalLink = true
}) => {
  const [creatingList, setCreatingList] = useState(false);
  const [hasCreateListError, setHasCreateListError] = useState(false);
  const [createListFromAssociatedLists] = useMutation(SAVE_NEW_ILS_LIST, {
    onCompleted: response => {
      const listId = response === null || response === void 0 ? void 0 : response.saveNewILSList.listId;
      if (listId) {
        listCreatedCallback(listId);
      }
      setCreatingList(false);
    },
    onError: error => {
      setCreatingList(false);
      setHasCreateListError(true);
      console.error(error);
    }
  });
  const trackEvent = useTrackEvent();
  const handleOnLinkClick = () => {
    if (!filterBranch) {
      return;
    }
    trackEvent(Trackables.CLICKED_CONTACT_CALCULATION_LISTS_LINK);
    if (!creatingList) {
      setCreatingList(true);
      setHasCreateListError(false);

      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      createListFromAssociatedLists({
        variables: {
          name: `[Workflows] - ${I18n.moment().toString()} - ${workflowName}`.substr(0, 125),
          filterBranch,
          objectTypeId
        }
      });
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "lists-access-link",
    children: [hasCreateListError && /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "automation-ui-enrollment.redesign.enrollExistingPanel.enrollFromList.linkPreviewFailed_cob",
        objectTypeId: objectTypeId
      }),
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "remove",
        className: "m-right-2",
        color: CANDY_APPLE
      })
    }), /*#__PURE__*/_jsx(UILink, {
      external: isExternalLink,
      onClick: handleOnLinkClick,
      disabled: creatingList,
      children: linkLabel
    }), creatingList && /*#__PURE__*/_jsx(UILoadingSpinner, {
      size: "extra-small",
      layout: "inline"
    })]
  });
};
export default ILSListPreviewLink;